import React from "react";

const ResumeContext = React.createContext();

export default ResumeContext;
